module.exports = __webpack_public_path__ + "media/images/flags/qa-54b9926864599fc7f9c78f4b2fe32a56.svg";